import { Injectable } from "@angular/core";
import { HttpService } from "../shared/services/http.service";
import { HelperService } from "../shared/services/helper.service";
import { environment } from "../../environments/environment";
import { HttpParams, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { UserApplicationViewModel } from "../models/application.user.model";

@Injectable()
export class UserService {

  private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyUserAdminApiEndPoint);
  private REQUEST_URL: string = `${this.BASE_URL}`; //${this.LISTA_USER_ENDPOINT}
  private URL: string;

  constructor(private httpService: HttpService) { }  
  

  public GetUserLoginMSA(filter:any) {    
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${localStorage.getItem("access_token")}`
      }),
      params: new HttpParams({
        fromObject: filter      
      })
    }; 


    //this.URL = `${this.REQUEST_URL}/GetUserLoginMSA`;
    this.URL = `${this.REQUEST_URL}/authentication/v1/getuserlogin`;
    return this.httpService.get<UserApplicationViewModel>(this.URL,httpOptions);
  }
}
